import { useCallback } from 'react'
import { useMutate } from 'restful-react'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import { useNotifications } from '@trileuco/triskel-react-ui/components/ui/notifications'
import { useErrorNotification } from 'modules/bookables/notifications'

const useSignUp = (options) => {
  const { mutate, ...rest } = useMutate({
    path: `/auth/signup/`,
    verb: 'POST',
    ...options
  })

  const { notifyError } = useErrorNotification()
  const {
    notify,
    statusTypes: { LOADING, SUCCESS }
  } = useNotifications()

  const { msg } = useIntl({
    scope: 'balaena.api.useSignUp',
    ignoreGlobalScope: true
  })
  const notifySignUp = useCallback(
    (notification) => {
      notify({
        id: 'SIGNUP',
        title: msg({ id: notification.status }),
        ...notification
      })
    },
    [msg, notify]
  )
  const signUp = useCallback(
    (params) => {
      notifySignUp({ status: LOADING })
      return mutate(params)
        .then((credentials) => {
          notifySignUp({ status: SUCCESS })
          return credentials
        })
        .catch((error) => {
          notifyError({
            id: 'SIGNUP',
            title: msg({ id: 'error' }),
            error
          })
          throw error
        })
    },
    [notifySignUp, LOADING, mutate, SUCCESS, notifyError, msg]
  )
  return {
    signUp,
    ...rest
  }
}

export default useSignUp
